// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_RESSOURCES } from "api/services/teacher/teacher.routes";

// Define a service using a base URL and expected endpoints
export const studentAdsApi = createApi({
  reducerPath: "studentAdsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_RESSOURCES,
  }),
  tagTypes: ["ADS"],
  endpoints: (builder) => ({
    searchTeacher: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: `/advertisements/reserve/search`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["ADS"],
    }),
    checkSaisson: builder.mutation<any, any>({
      query: (parmams) => {
        return {
          url: `advertisements/instaProf/newRequest/prof/checkSaisson/${parmams.idTeacher}`,
          method: "Get",
        };
      },
      invalidatesTags: ["ADS"],
    }),
    searchOrganismTeacher: builder.query<any, any>({
      query: (organismId) => {
        return {
          url: `/users/organisme/teachers/fetch/${organismId}`,
          method: "GET",
        };
      },
      providesTags: ["ADS"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useSearchTeacherMutation, useCheckSaissonMutation, useSearchOrganismTeacherQuery } =
  studentAdsApi;
